<template>
  <div class="footer-component">
    <div class="left">
      <img class="dalk" :src="baseUrl+'icons/'+content.logo2+'.svg'">
      <img class="tva" :src="baseUrl+'icons/'+content.logo1+'.svg'">
    </div>
    <div class="right">
      <p>For</p>
      <img class="terna" :src="baseUrl+'icons/'+content.logo3+'.svg'">
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      device: ""
    };
  },
  created() {
    this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    window.addEventListener("resize", () => {
      this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    });
    if (process.env.VUE_APP_LANG === "IT") {
      return (this.lang = "it");
    } else {
      return (this.lang = "en");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.footer-component {
  height: 70px;
  background: black;
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-top: -50px;
  .left,
  .right {
    display: flex;
    align-items: center;
    p {
      font-family: "Oswald", sans-serif;
      font-size: 17px;
      text-transform: uppercase;
      color: white;
      margin-right: 20px;
      margin-bottom: 0 !important;
      margin-top: 0 !important;
    }
    img {
      height: 20px;
      margin-right: 20px;
      &.tva {
        width: 250px;
      }
    }
  }
}
@media (max-width: 768px) {
  .footer-component {
    height: 240px;
    flex-direction: column;
    justify-content: center;
    .left,
    .right {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      p {
        margin-bottom: 5px;
      }
      img {
        margin-bottom: 10px;
        &.tva {
          margin-left: -5px;
        }
      }
    }
    .left {
      margin-bottom: 15px;
    }
  }
}
</style>